import { lazy } from "react";
import Loadable from "components/Loadable";

const CommunityList = Loadable(
  lazy(() => import("features/community/components/List"))
);
const CommunityPage = Loadable(
  lazy(() => import("features/community/components/Page"))
);

const routes = {
  path: "community",
  children: [
    { path: "", element: <CommunityList /> },
    { path: "add", element: <CommunityPage /> },
    { path: "edit/:id?", element: <CommunityPage /> },
  ],
};

export default routes;
